export default {
  list: () => import('./list/index.vue'), // 会员列表
  addVIPCard: () => import('./addVIPCard/index.vue'), // 添加VIP卡类型
  vipMember: () => import('./vipMember/index.vue'), // VIP会员列表
  rechargeRecord: () => import('./rechargeRecord/index.vue'), // 会员卡充值记录
  managementSmsRecord: () => import('./managementSmsRecord/index.vue'), // 短信记录
  mangementCouponRecord: () => import('./mangementCouponRecord/index.vue'), // 优惠券记录
};
  